import { Button } from "@src/lib/ui/Button";
import {
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenu,
  DropdownMenuCheckboxItem,
} from "@src/lib/ui/DropdownMenu";
import ChevronDownIcon from "@src/lib/icons/12px/chevron-down";
import useVersionQueryParams from "@src/features/libraryItem/hooks/useVersionQueryParams";
import { TrainingResourceVersionFragment } from "@src/fragments.generated";

interface Props {
  trainingResourceVersion?: TrainingResourceVersionFragment;
}

const TrainingResourceVersionHistoryDropdown: React.FC<Props> = (props) => {
  const { version, setVersion } = useVersionQueryParams();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline">
          Version: {version === "published" ? "Published" : "Draft"}{" "}
          <ChevronDownIcon />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuCheckboxItem
          checked={version === "draft"}
          onCheckedChange={() => setVersion("draft")}
        >
          Draft
        </DropdownMenuCheckboxItem>
        <DropdownMenuCheckboxItem
          disabled={
            !props.trainingResourceVersion?.trainingResource?.publishedVersion
          }
          checked={version === "published"}
          onCheckedChange={() => setVersion("published")}
        >
          Published
        </DropdownMenuCheckboxItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default TrainingResourceVersionHistoryDropdown;
